import { useEffect, useRef, useState } from "react";
import { solvePow } from "./api";

export function useSeo(title, description, noindex = false) {
  useEffect(() => {
    document.title = title ? `${title} | Studio Diolosa – Commercialisti` : "Studio Diolosa – Commercialisti a Spilimbergo (PN)";
    const set = (name, content) => {
      let m = document.querySelector(`meta[name="${name}"]`);
      if (!m) { m = document.createElement("meta"); m.setAttribute("name", name); document.head.appendChild(m); }
      m.setAttribute("content", content);
    };
    if (description) set("description", description);
    set("robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, noindex]);
}

export function useAntiBot() {
  const started = useRef(Date.now());
  const [hp, setHp] = useState("");
  const payload = async () => ({ ...(await solvePow()), website: hp, started_at: started.current });
  const field = (
    <div aria-hidden="true" style={{ position: "absolute", left: "-10000px", width: 1, height: 1, overflow: "hidden" }}>
      <label htmlFor="website">Lasciare vuoto</label>
      <input id="website" name="website" tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} />
    </div>
  );
  return { payload, field };
}

const CONSENT_KEY = "sd_consent_v1";
const CONSENT_MAX_DAYS = 180;
export const getConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(CONSENT_KEY));
    if (c?.at && Date.now() - new Date(c.at).getTime() > CONSENT_MAX_DAYS * 86400000) { localStorage.removeItem(CONSENT_KEY); return null; }
    return c;
  } catch { return null; }
};
export const setConsent = (c) => { localStorage.setItem(CONSENT_KEY, JSON.stringify({ ...c, at: new Date().toISOString() })); window.dispatchEvent(new Event("consent")); };
export function useConsent() {
  const [c, setC] = useState(getConsent());
  useEffect(() => { const h = () => setC(getConsent()); window.addEventListener("consent", h); return () => window.removeEventListener("consent", h); }, []);
  return c;
}
